/* eslint-disable @angular-eslint/component-selector */
import { Component } from '@angular/core';
import { assetsConst } from 'src/app/core/const/assets.const';

@Component({
  selector: 'megastore-add-walkthrough',
  templateUrl: './add-walkthrough.component.html',
  styleUrls: ['./add-walkthrough.component.scss']
})
export class AddWalkthroughComponent {
  assetsConst = assetsConst;
}
